import React, { FC } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'react-recompose';
import { AccessTokenPayload } from '@dev/ee-api/ee-api-models';
import { AddAccessToken as SettingsModule } from '@dev/ee-modules';
import { push as Push } from 'redux-first-history';
import { ApplicationState as State } from '@/store';
import { ShowDialog } from '@/store/dialog/actions';
import {
    AccessTokensLoadingStart,
    AccessTokenAdd,
    AccessTokenUpdate,
    HideAccessTokenCredentials,
} from '@/store/security/actions';
import { ShowDialogParams } from '@/store/dialog/types';

import { SettingsPaths, APIPaths } from '@/services/dictionaries/Paths';
import dayjs from '@/services/tools/dayjs';
import { AccessTokensProps as Props } from '../AccessTokenInterface';

const mapState = (state: State, ownProps: Props): Props => ({
    ...ownProps,
    account: state.account,
    browser: state.browser,
    dialog: state.dialog,
    security: state.security,
});
const dispatchProps = {
    ShowDialog,
    AccessTokensLoadingStart,
    AccessTokenAdd,
    AccessTokenUpdate,
    HideAccessTokenCredentials,
    Push,
};
interface DispatchProps {
    ShowDialog(params: ShowDialogParams): void;
    AccessTokensLoadingStart(): void;
    AccessTokenAdd(accessToken: AccessTokenPayload): void;
    AccessTokenUpdate(name: string, body: AccessTokenPayload): void;
    HideAccessTokenCredentials(): void;
    Push(url: string): void;
}

type ExtendedProps = Props & DispatchProps;

const AddSMTP: FC<ExtendedProps> = (props: ExtendedProps): JSX.Element => (
    <SettingsModule dayjs={dayjs} {...props} paths={{ ...SettingsPaths, ...APIPaths }} />
);

export default compose(withTranslation('settings'), connect<Props, DispatchProps>(mapState, dispatchProps))(AddSMTP);
